import { gql } from "@apollo/client";


export const startConversation = gql`
    mutation startConversation($StartConversationInput: touchless_conversation_initiated_insert_input!) @api(name: "touchless") {
    startConversation: insert_touchless_conversation_initiated_one(object: $StartConversationInput) {
      uuid: parent_uuid
    }
  }
  
`;

export const saveOptOut = gql`
    mutation SaveOptOut($conversationId: uuid!, $channelTypes: ChannelTypeEnum) @api(name: "touchless") {
        update_api_ui_aggregated_conversation(where: {conversation_id: {_eq: $conversationId}}, _set: {opt_out: $channelTypes})
    }
`;

export const updateConversationCategory = gql`
    mutation updateConversationCategory($conversationId: uuid!, $conversationStatus: touchless__state_enum!)  @api(name: "touchless") {
        update_conversation: update_touchless_conversation(where: {uuid: {_eq: $conversationId}}, _set: {state: $conversationStatus}) {
            affected_rows
        }
    }
`;

export const saveConversationCall = gql`
    mutation saveConversationCall($SaveConversationCallInput: SaveConversationCallInput!) @api(name: "textkit") {
        saveConversationCall(input: $SaveConversationCallInput)
    }
`;

export const assignRepresentativeToContact = gql`
    mutation assignRepresentativeToContact($conversationId:uuid, $participantId: uuid) @api(name: "touchless") {
        update_touchless_conversation(where: {uuid: {_eq: $conversationId}}, _set: {actor_uuid: $participantId}) {
            affected_rows
        }
    }
`;

// export const hydrateConversation = gql`
//     mutation hydrateConversation($conversationId: ID!) @api(name: "textkit") {
//         hydrateConversation(conversationId: $conversationId)
//     }
// `;

export const hydrateConversation = gql`
    mutation hydrateConversation($conversationId: uuid!, $hydration:String) @api(name: "touchless") {
        hydrateConversation: update_touchless_conversation_by_pk(pk_columns: {uuid: $conversationId}, _set: {hydration: $hydration}) {
            hydration
        }
    }
`;

export const updateContact = gql`
    mutation updateContact($contactId: uuid,  $businessName:String, $lastName:String, $middleName:String, $firstName:String, $locale:String) @api(name: "touchless") {
        contact: update_touchless_contact(where: {uuid: {_eq: $contactId}}, _set: {
            family_name: $lastName, 
            middle_name: $middleName,
            name_business: $businessName,
            given_name: $firstName, 
            locale: $locale}) {
            affected_rows
        }
    }
`;

export const saveRepresentativeIncomingAvailable = gql`
    mutation saveRepresentativeIncomingAvailable($repId: uuid!, $customerId: uuid!, $availability: Boolean!) @api(name: "touchless") {
        update_touchless_representative_by_pk(pk_columns: {parent_config_uuid: $customerId, uuid: $repId}, _set: {is_accepting_incoming: $availability}) {
            uuid
        }
    }
`;

export const manageRepresentativeIncomingAvailable = gql`
    mutation manageRepresentativeIncomingAvailable($ManageRepresentativeIncomingAvailableInput: ManageRepresentativeIncomingAvailableInput) @api(name: "textkit") {
        manageRepresentativeIncomingAvailable(input: $ManageRepresentativeIncomingAvailableInput)
    }
`;

export const createContact = gql`
    mutation createContact($CreateContactInput: touchless_contact_insert_input!) @api(name: "touchless") {
        createContact: insert_touchless_contact_one(object: $CreateContactInput) {
            uuid
        }
    }
`;